"use strict";

var _regeneratorRuntime = require("/home/livesetup/Desktop/Blockchain/Dapp/kigali-dex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var utils_1 = require("@walletconnect/utils");

var AES_ALGORITHM = "AES-CBC";
var AES_LENGTH = 256;
var HMAC_ALGORITHM = "SHA-256";

function exportKey(cryptoKey) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var browserCrypto, buffer;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            browserCrypto = utils_1.getCrypto();
            _context.next = 3;
            return browserCrypto.subtle.exportKey("raw", cryptoKey);

          case 3:
            buffer = _context.sent;
            return _context.abrupt("return", buffer);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.exportKey = exportKey;

function importKey(buffer) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : AES_ALGORITHM;
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var aesParams, hmacParams, algoParams, usages, browserCrypto, cryptoKey;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            aesParams = {
              length: AES_LENGTH,
              name: AES_ALGORITHM
            };
            hmacParams = {
              hash: {
                name: HMAC_ALGORITHM
              },
              name: "HMAC"
            };
            algoParams = type === AES_ALGORITHM ? aesParams : hmacParams;
            usages = type === AES_ALGORITHM ? ["encrypt", "decrypt"] : ["sign", "verify"];
            browserCrypto = utils_1.getCrypto();
            _context2.next = 7;
            return browserCrypto.subtle.importKey("raw", buffer, algoParams, true, usages);

          case 7:
            cryptoKey = _context2.sent;
            return _context2.abrupt("return", cryptoKey);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

exports.importKey = importKey;

function generateKey(length) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _length, browserCrypto, cryptoKey, key;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _length = length || 256;
            browserCrypto = utils_1.getCrypto();
            _context3.next = 4;
            return browserCrypto.subtle.generateKey({
              length: _length,
              name: AES_ALGORITHM
            }, true, ["encrypt", "decrypt"]);

          case 4:
            cryptoKey = _context3.sent;
            _context3.next = 7;
            return exportKey(cryptoKey);

          case 7:
            key = _context3.sent;
            return _context3.abrupt("return", key);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

exports.generateKey = generateKey;

function createHmac(data, key) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var cryptoKey, browserCrypto, signature;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return importKey(key, "HMAC");

          case 2:
            cryptoKey = _context4.sent;
            browserCrypto = utils_1.getCrypto();
            _context4.next = 6;
            return browserCrypto.subtle.sign({
              length: 256,
              name: "HMAC"
            }, cryptoKey, data);

          case 6:
            signature = _context4.sent;
            return _context4.abrupt("return", signature);

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}

exports.createHmac = createHmac;

function verifyHmac(payload, key) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var cipherText, iv, hmac, hmacHex, unsigned, chmac, chmacHex;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            cipherText = utils_1.convertHexToArrayBuffer(payload.data);
            iv = utils_1.convertHexToArrayBuffer(payload.iv);
            hmac = utils_1.convertHexToArrayBuffer(payload.hmac);
            hmacHex = utils_1.convertArrayBufferToHex(hmac, true);
            unsigned = utils_1.concatArrayBuffers(cipherText, iv);
            _context5.next = 7;
            return createHmac(unsigned, key);

          case 7:
            chmac = _context5.sent;
            chmacHex = utils_1.convertArrayBufferToHex(chmac, true);

            if (!(utils_1.removeHexPrefix(hmacHex) === utils_1.removeHexPrefix(chmacHex))) {
              _context5.next = 11;
              break;
            }

            return _context5.abrupt("return", true);

          case 11:
            return _context5.abrupt("return", false);

          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
}

exports.verifyHmac = verifyHmac;

function aesCbcEncrypt(data, key, iv) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var cryptoKey, browserCrypto, result;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return importKey(key, AES_ALGORITHM);

          case 2:
            cryptoKey = _context6.sent;
            browserCrypto = utils_1.getCrypto();
            _context6.next = 6;
            return browserCrypto.subtle.encrypt({
              iv: iv,
              name: AES_ALGORITHM
            }, cryptoKey, data);

          case 6:
            result = _context6.sent;
            return _context6.abrupt("return", result);

          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
}

exports.aesCbcEncrypt = aesCbcEncrypt;

function aesCbcDecrypt(data, key, iv) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var cryptoKey, browserCrypto, result;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return importKey(key, AES_ALGORITHM);

          case 2:
            cryptoKey = _context7.sent;
            browserCrypto = utils_1.getCrypto();
            _context7.next = 6;
            return browserCrypto.subtle.decrypt({
              iv: iv,
              name: AES_ALGORITHM
            }, cryptoKey, data);

          case 6:
            result = _context7.sent;
            return _context7.abrupt("return", result);

          case 8:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
}

exports.aesCbcDecrypt = aesCbcDecrypt;

function encrypt(data, key, providedIv) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    var iv, ivHex, contentString, content, cipherText, cipherTextHex, unsigned, hmac, hmacHex;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (key) {
              _context8.next = 2;
              break;
            }

            throw new Error("Missing key: required for encryption");

          case 2:
            _context8.t0 = providedIv;

            if (_context8.t0) {
              _context8.next = 7;
              break;
            }

            _context8.next = 6;
            return generateKey(128);

          case 6:
            _context8.t0 = _context8.sent;

          case 7:
            iv = _context8.t0;
            ivHex = utils_1.convertArrayBufferToHex(iv, true);
            contentString = JSON.stringify(data);
            content = utils_1.convertUtf8ToArrayBuffer(contentString);
            _context8.next = 13;
            return aesCbcEncrypt(content, key, iv);

          case 13:
            cipherText = _context8.sent;
            cipherTextHex = utils_1.convertArrayBufferToHex(cipherText, true);
            unsigned = utils_1.concatArrayBuffers(cipherText, iv);
            _context8.next = 18;
            return createHmac(unsigned, key);

          case 18:
            hmac = _context8.sent;
            hmacHex = utils_1.convertArrayBufferToHex(hmac, true);
            return _context8.abrupt("return", {
              data: cipherTextHex,
              hmac: hmacHex,
              iv: ivHex
            });

          case 21:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
}

exports.encrypt = encrypt;

function decrypt(payload, key) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    var verified, cipherText, iv, buffer, utf8, data;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (key) {
              _context9.next = 2;
              break;
            }

            throw new Error("Missing key: required for decryption");

          case 2:
            _context9.next = 4;
            return verifyHmac(payload, key);

          case 4:
            verified = _context9.sent;

            if (verified) {
              _context9.next = 7;
              break;
            }

            return _context9.abrupt("return", null);

          case 7:
            cipherText = utils_1.convertHexToArrayBuffer(payload.data);
            iv = utils_1.convertHexToArrayBuffer(payload.iv);
            _context9.next = 11;
            return aesCbcDecrypt(cipherText, key, iv);

          case 11:
            buffer = _context9.sent;
            utf8 = utils_1.convertArrayBufferToUtf8(buffer);
            _context9.prev = 13;
            data = JSON.parse(utf8);
            _context9.next = 20;
            break;

          case 17:
            _context9.prev = 17;
            _context9.t0 = _context9["catch"](13);
            return _context9.abrupt("return", null);

          case 20:
            return _context9.abrupt("return", data);

          case 21:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[13, 17]]);
  }));
}

exports.decrypt = decrypt;